export const Colors = {
  background: "#F7F8FC",
};
